
export class PreloadScene extends Phaser.Scene {

    constructor() {
        super({
            key: 'PreloadScene',
        });
    }

    public preload() {
        // var baseUrl = "/imgsGame/"//local
        var baseUrl = "/magazin/juegos/nosotras-al-poder/imgsGame/"
        this.load.image('fondo', baseUrl + 'fondo_ciudad.png');
        this.load.image('player', baseUrl + 'nina.png');
        this.load.image('rayito', baseUrl + 'rayito.png'); 
        this.load.image('rayito2', baseUrl + 'rayo_poderoso.png'); 
        this.load.image('platform', baseUrl + 'platform.png');
        this.load.image('platform_lateral', baseUrl + 'platform_lateral.png');
        this.load.image('corazon', baseUrl + 'corazon.png');
        this.load.image('Obstacle1', baseUrl + 'desigualdad.png');
        this.load.image('Obstacle2', baseUrl + 'debil.png');
        this.load.image('Obstacle3', baseUrl + 'inutil.png');
        this.load.image('Obstacle4', baseUrl + 'irrespeto.png');
        this.load.image('Obstacle5', baseUrl + 'machismo.png');
        this.load.image('btnShooter', baseUrl + 'boton_disparar.png');
    }

    public create() {
        this.game.scene.start('PlayScene');
    }

}
